import {Input, Typography} from 'antd'
import {IconSearch} from 'components/icons'

interface IOrderWarehouseFilter {
  invoiceNumber: string
  setInvoiceNumber: (val: string) => void
  searchOrderWarehouse: () => void
  isLoadingSearch: boolean
}

const OrderConfirmationFilter = (props: IOrderWarehouseFilter) => {

  const handleInvoiceNumberChange = (value: string) => {
    props.setInvoiceNumber(value);
  };

  return (
    <div className="w-full">
      <div className="md:flex justify-between w-full gap-3">
        <div>
          <Typography>
            <Typography.Title level={3} style={{margin: 0}}>
              Cari Invoice
            </Typography.Title>
          </Typography>
        </div>
        <div className="basis-1/2">
          <Input
            prefix={<IconSearch/>}
            size="large"
            data-testid="input_search_invoice"
            placeholder="INV/20230911/PAS/101717"
            disabled={props.isLoadingSearch}
            value={props.invoiceNumber}
            onChange={(e) => handleInvoiceNumberChange(e.target.value)}
            onPressEnter={props.searchOrderWarehouse}
          />
        </div>
      </div>
    </div>
  )
}

export default OrderConfirmationFilter
